
export default {
  props: {
    articles: {
      type: Array,
      default: () => [],
    },
    content: {
      type: Array,
      default: () => [],
    },
    episodes: {
      type: Array,
      default: () => [],
    },
    extraContent: {
      type: Array,
      default: () => [],
    },
    genreName: {
      type: String,
      default: null,
    },
    hero: {
      type: Object,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    intro: {
      type: String,
      default: null,
    },
    logo: {
      type: String,
      default: null,
    },
    modelName: {
      type: String,
      default: null,
    },
    platforms: {
      type: Array,
      default: () => [],
    },
    presenters: {
      type: Array,
      default: () => [],
    },
    slug: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    topic: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: null,
    },
  },
  asyncData ({ store, route, params: { slug } }) {
    // Set breadcrumbs for the page
    store.dispatch('breadcrumbs/mirror', {
      path: route.path,
      mirror: `/programmas/${slug}`,
    })
  },
}
